export const ADD_EXPENSE = "ADD_EXPENSE";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const GET_EXPENSE = "GET_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const GET_CLOSING_EXPENSE = "GET_CLOSING_EXPENSE"
